<template>
  <div>
    <title>开票商品管理</title>
    <section class="mainPart">
      <!--S 检索-->      
      <el-form :inline="true" :model="searchForm" class="searchForm">
          <el-form-item label="销售方">
             <BuyerAndSellerSelecr :roleType="1"  :eleType="'1'"  @invoiceObtain="senderObtain3"></BuyerAndSellerSelecr>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input clearable v-model="searchForm.invgoodsname" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input clearable v-model="searchForm.invkindinfo" placeholder="请输入规格型号"></el-input>
          </el-form-item>
          <el-form-item label="税率">
            <el-input clearable v-model="searchForm.taxrate" placeholder="请输入税率">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="状态" class="formTimeSlot">
            <el-select v-model="searchForm.status" placeholder="请选择" clearable>
              <el-option label="启用" :value="0"></el-option>
              <el-option label="禁用" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="querySubmit">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="exportList()">导出</el-button>
          </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <div class="gsListTable individualiz">
        <el-table class="comTable orderTable" ref="gsTable" :data="payRecordList" border :maxHeight="tableHeight">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="销售方" min-width="200">
            <template slot-scope="scope">
              <p class="textFl pdr70" :title="scope.row.salername">{{scope.row.salername}}</p>
            </template>
          </el-table-column>
          <el-table-column label="产品名称" min-width="200">
            <template slot-scope="scope">
              <p class="textFl pdr70" :title="scope.row.invgoodsname">{{scope.row.invgoodsname}}</p>
            </template>
          </el-table-column>
          <el-table-column label="规格型号"  min-width="200">
            <template slot-scope="scope">
              <p class="textFl pdr70" :title="scope.row.invkindinfo">{{scope.row.invkindinfo}}</p>
            </template>
          </el-table-column>
          <el-table-column label="小数点开票"  min-width="120">
            <template slot-scope="scope">
              <el-switch disabled :value="scope.row.issuppdecimal?true:false"  :width="45" class="isSwitch" :active-text="scope.row.issuppdecimal?'是':'否'"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="单位" min-width="80">
            <template slot-scope="scope">
              <p>{{scope.row.unit}}</p>
            </template>
          </el-table-column>
          <el-table-column label="可用库存" min-width="200" sortable prop="availableinv">
            <template slot-scope="scope">
              <template v-if="userInfoMd&&(userInfoMd.objtype=0 || userInfoMd.isopenfinancial)">
                <p class="priceFont greenColor cursorHand" @click="getShowAvailableinv(scope.row.invgoodscode)"><i class="iconhand"></i>{{scope.row.availableinv}}</p>
              </template> 
              <p v-else>{{scope.row.availableinv}}</p>
            </template>
          </el-table-column>
          <el-table-column label="已消耗库存" min-width="200" sortable prop="availableinv">
            <template slot-scope="scope">
              <template v-if="userInfoMd&&(userInfoMd.objtype=0 || userInfoMd.isopenfinancial)">
                <p class="priceFont redColor cursorHand" v-if="scope.row.consumeinv>0" @click="getShowConsumeinv(scope.row.invgoodscode)"><i class="iconhand"></i>{{scope.row.consumeinv}}</p>
                <p v-else class="priceFont redColor pl25">0</p>
              </template>
              <p v-else>{{scope.row.consumeinv}}</p>
            </template>
          </el-table-column>
          <el-table-column label="单价区间(￥)" min-width="200" sortable prop="unitprice">
            <template slot-scope="scope">
              <p>{{scope.row.unitprice}} <b v-if="scope.row.minprice">({{scope.row.minprice}}-{{scope.row.maxprice}})</b></p>
            </template>
          </el-table-column>
          <el-table-column label="税率(%)" min-width="100" sortable prop="taxrate">
            <template slot-scope="scope">
              <p>{{scope.row.taxrate}}</p>
            </template>
          </el-table-column>
          <el-table-column label="状态" sortable prop="status" width="120">
            <template slot-scope="scope">
              <el-switch :disabled="monye" :value="scope.row.status?false:true" @change="handleStatus(scope.row)"  :width="45" class="isSwitch" :active-text="!scope.row.status?'启':'禁'"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <p class="handle">
                  <span class="detailA" title="详情" @click="getDetailShow(scope.row)"><i class="icondetails"></i></span>
                  <el-popover placement="bottom" width="300" trigger="click" @show="mallShowPop(scope.$index,scope.row)" @hide="mallClosePop(scope.$index)" v-if="userInfoMd&&userInfoMd.isopenfinancial">
                      <el-form :model="addRedForm" class="setForm">
                        <el-form-item class="addItem">
                          <em>单价区间{{scope.$Index}}</em>
                          <el-form-item class="serialInput">
                              <el-input v-model="addRedForm.minprice" clearable maxlength="9"></el-input>
                              <small>~</small>
                              <el-input v-model="addRedForm.maxprice" clearable maxlength="9"></el-input>
                          </el-form-item>
                        </el-form-item>
                        <el-form-item class="addItem">
                          <em>小数点开票</em>
                          <el-switch
                            v-model="addRedForm.issuppdecimal"
                            :width="45"
                            class="isSwitch"
                            :active-text="addRedForm.issuppdecimal?'是':'否'">
                          </el-switch>
                        </el-form-item>
                      </el-form>
                      <div class="center">
                          <el-button type="primary" size="mini" @click="getClosePop(1,scope.row)">确定</el-button>
                          <el-button size="mini" @click="getClosePop">取消</el-button>
                      </div>
                      <span v-if="!monye" :title="scope.row.minprice ? '编辑单价区间' : '设置单价区间'"  slot="reference"><i class="iconedit"></i></span>
                  </el-popover>
                </p>
              </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
      </div>
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
    </section>
    <!--S 详情-->
    <el-dialog :visible.sync="transferDetailShow" class="comDlog seniorMdg" title="详请" :modal-append-to-body="false" append-to-body :close-on-click-modal="false">
      <div class="flexAro basicWrap">
        <ul>
          <li class="rulrMemo">
            <em>销售方：</em>
            <b :title="transferInfo.salername">{{transferInfo.salername}}</b>
          </li>
          <li class="rulrMemo">
            <em>产品名称：</em>
            <b :title="transferInfo.invgoodsname">{{transferInfo.invgoodsname}}</b>
          </li>
          <li class="rulrMemo">
            <em>规格型号：</em>
            <b :title="transferInfo.invkindinfo">{{transferInfo.invkindinfo}}</b>
          </li>
          <li>
            <em>单位：</em>
            <b>{{transferInfo.unit}}</b>
          </li>
          <li>
            <em>可用库存：</em>
            <!-- <b class="greenColor cursorHand" @click="getShowAvailableinv" v-if="transferInfo.availableinv>0" title="点击查看商品采购明细"><i class="iconhand"></i>{{transferInfo.availableinv}}</b> -->
            <b class="greenColor">{{transferInfo.availableinv}}</b>
          </li>
          <li>
            <em>已消耗库存：</em>
            <!-- <b class="redColor cursorHand" @click="getShowConsumeinv" v-if="transferInfo.consumeinv>0" title="点击查看开票申请明细"><i class="iconhand"></i>{{transferInfo.consumeinv}}</b> -->
            <b class="redColor">{{transferInfo.consumeinv}}</b>
          </li>
          <li>
            <em>单价(￥)：</em>
            <b>{{transferInfo.unitprice}}</b>
          </li>
          <li>
            <em>单价区间(￥)：</em>
            <b>{{transferInfo.minprice}}-{{transferInfo.maxprice}}</b>
          </li>
          <li>
            <em>税率(%)：</em>
            <b>{{transferInfo.taxrate}}</b>
          </li>
          <li>
            <em>状态：</em>
            <b>
              <el-switch :value="transferInfo.status?false:true"  :width="45" class="isSwitch" :active-text="!transferInfo.status?'启':'禁'"></el-switch>
              </b>
          </li>
          <li>
            <em>备注：</em>
            <b>{{transferInfo.memo ||'--'}}</b>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getDetailClose">关闭</el-button>
      </div>
    </el-dialog>
    <!--E 详情-->
    <!-- S 商品采购明细 -->
		<el-dialog class="comDlog recordDlog" :visible.sync="availableinvDlog" :before-close="getCloseAvailableinv" append-to-body :close-on-click-modal="false" title="商品采购明细" v-loading="loading">
			<p class="topButton">
        <el-button type="primary" plain @click="exportPurdetailListByInvgoodscode">导出</el-button>
      </p>
      <div class="allOrderTab">
				<el-table :data="purRecordData" ref="invoiceRecord" class="comTable" border :maxHeight="490">         
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column label="采购人" min-width="200">
						<template slot-scope="scope">
							<p class="textFl pdr70" :title="scope.row.puruname">{{scope.row.puruname}}</p>
              <small class="greyColor">{{scope.row.verifydate | dateFormate(1)}}</small>
						</template>
					</el-table-column>
          <el-table-column label="供应商" min-width="180">
						<template slot-scope="scope">
              <p class="textFl pdr70" :title="scope.row.supplyername">{{scope.row.supplyername}}</p>
            </template>
          </el-table-column>
          <el-table-column label="产品名称" min-width="300">
						<template slot-scope="scope">
							<p class="textFl pdr70" :title="scope.row.invgoodsname">{{scope.row.invgoodsname}}</p>
              <span class="textFl pdr70" :title="scope.row.invkindinfo">{{scope.row.invkindinfo}}</span>
						</template>
					</el-table-column>
          <el-table-column label="单价(￥) / 单位" min-width="200">
						<template slot-scope="scope">
							<p>{{scope.row.unitprice}} / {{scope.row.unit}}</p>
						</template>
					</el-table-column>
          <el-table-column label="采购数量" min-width="150">
						<template slot-scope="scope">
							<p class="greenColor">+{{scope.row.num}}</p>
						</template>
					</el-table-column>
          <el-table-column label="采购说明" min-width="200">
						<template slot-scope="scope">
							<p class="txtLineTwo" :title="scope.row.purinstructions">{{scope.row.purinstructions?scope.row.purinstructions:'--'}}</p>
						</template>
					</el-table-column>
					<template slot="empty">
						<div class="noData"><span>暂无数据</span></div>
					</template>
				</el-table>
			</div>
      <!-- S 分页 -->
      <Page :pageTotal="purPagebBean.totalnum" :currentPage="purCurrentPage" @nowPageParam="purUpdatePage"></Page>
      <!-- S 分页 -->
			<span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCloseAvailableinv">关闭</el-button>
      </span>
		</el-dialog>
		<!-- E 商品采购明细 -->
    <!-- S 开票明细 -->
		<el-dialog class="comDlog recordDlog" :visible.sync="consumeinvDlog" :before-close="getCloseConsumeinv" append-to-body :close-on-click-modal="false" title="开票申请明细" v-loading="loading">
			<p class="topButton">
        <el-button type="primary" plain @click="exportInvoiceListByInvgoodscode">导出</el-button>
      </p>
      <div class="allOrderTab">
				<el-table :data="invoiceRecordData" ref="invoiceRecord" class="comTable" border :maxHeight="490">         
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column label="申请开票人" min-width="200">
						<template slot-scope="scope">
							<p class="textFl pdr70" :title="scope.row.applyuname">{{scope.row.applyuname}}</p>
              <small class="greyColor">{{scope.row.applydate | dateFormate(1)}}</small>
						</template>
					</el-table-column>
          <el-table-column label="产品名称" min-width="300">
						<template slot-scope="scope">
							<p class="textFl pdr70" :title="scope.row.invgoodsname">{{scope.row.invgoodsname}}</p>
              <span class="textFl pdr70" :title="scope.row.invkindinfo">{{scope.row.invkindinfo}}</span>
						</template>
					</el-table-column>
          <el-table-column label="单价(￥) / 单位" min-width="200">
						<template slot-scope="scope">
							<p>{{scope.row.unitprice}} / {{scope.row.unit}}</p>
						</template>
					</el-table-column>
          <el-table-column label="开票数量" min-width="150">
						<template slot-scope="scope">
							<p class="redColor">-{{scope.row.num}}</p>
						</template>
					</el-table-column>
          <el-table-column label="审核状态" prop="status" sortable min-width="240">
            <template slot-scope="scope">
              <p class="textFl" :class="[{'orangeColor':scope.row.status==0},{'greenColor': scope.row.status==1},{'redColor':scope.row.status==2},{'blueColor':scope.row.status==3},{'greyColor':scope.row.status==4 || scope.row.status==5}]">{{scope.row.status | auditStatusilter}}</p>
              <small class="greyColor">发票号:{{scope.row.invoiceno | empty}}</small>
            </template>
          </el-table-column>
					<template slot="empty">
						<div class="noData"><span>暂无数据</span></div>
					</template>
				</el-table>
			</div>
      <!-- S 分页 -->
      <Page :pageTotal="purPagebBean.totalnum" :currentPage="purCurrentPage" @nowPageParam="invUpdatePage"></Page>
      <!-- S 分页 -->
			<span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCloseConsumeinv">关闭</el-button>
      </span>
		</el-dialog>
		<!-- E 开票明细 -->
  </div>
</template>
<script>
import Vue from 'vue';
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
  name: 'InvoiceGoodsManage',
  data () {
    return {
      monye:false,
      //检索
      searchForm: {
        salercode: "",//销售方编号
        invgoodsname:'',//产品名称
        invkindinfo:'',//规格名称
        taxrate:'',//税率
        status:'',//状态，0：启用；1：禁用
      },
      payRecordList:[],
      tableHeight: window.innerHeight*.8, //表格动态高度
      transferDetailShow:false,//详情弹窗
      transferInfo:'',//详情信息
      addRedForm:{
        minprice:'',
        maxprice:'',
        issuppdecimal: false, // 是否支持散开
      },//单价区间表单
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
      userInfoMd: '', // 登录信息
      availableinvDlog:false,//商品采购明细弹窗
      invoiceRecordData:[], // 开票申请明细列表
      consumeinvDlog:false,// 开票申请明细弹窗
      purRecordData: [], // 获取的商品采购明细列表
      purPageSize: 30, // 每页展示的条数
      purCurrentPage: 1, // 当前请求的页数
      purPagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
      purdetailCode: '', // 查看的开票商品code
      loading: false, // 加载中遮罩
    }
  },
  filters: {
    //发票审核状态过滤
    auditStatusilter(value){
      if (value == 0) {
        return '待审核';
      } else if (value == 1) {
        return '审核通过，待开票';
      } else if (value == 2) {
        return '审核不通过';
      } else if (value == 3) {
        return '审核通过，已开票';
      } else if (value == 4) {
        return '已取消';
      } else if (value == 5) {
        return '已作废';
      } 
    },
  },
  components: {
    BuyerAndSellerSelecr: resolve => require(["@/components/InvoiceManage/BuyerAndSellerSelecr.vue"],resolve),
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
  },
  watch: {
    'addRedForm.minprice'(val) {
      this.addRedForm.minprice = this.amountChech(val);
    },
    'addRedForm.maxprice'(val) {
      this.addRedForm.maxprice = this.amountChech(val);
    },
    'searchForm.taxrate'(val) {
      this.searchForm.taxrate = this.integerCheck(val);
    }
  },
  methods: {
    // 打开商品采购明细弹窗
    getShowAvailableinv(code){
      this.purdetailCode = code;
      this.purPageSize = 30;
      this.purCurrentPage = 1;
      this.getPurdetailListByInvgoodscode();
    },
    // 关闭商品采购明细弹窗
    getCloseAvailableinv(){
      this.availableinvDlog = false;
    },
    // 获取商品采购明细列表
    getPurdetailListByInvgoodscode() {
      let getParams = {
        invgoodscode: this.purdetailCode,
        pageparam: {
          pagesize: this.purPageSize, //每页条数
          currentpage: this.purCurrentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      api.GET_PURDETAILLISTBYINVGOODSCODE(getParams).then(res => {
        if(res.data.status == "200") {
          this.purRecordData = res.data.data;
          this.purPagebBean = res.data.pagebean;
          this.availableinvDlog = true;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    // 接收分页信息
    purUpdatePage(size,num) {
      this.purPageSize = size;
      this.purCurrentPage = num;
      this.getPurdetailListByInvgoodscode();
    },
    // 导出商品采购明细列表
    exportPurdetailListByInvgoodscode() {
      this.loading = true;
      api.EXPORTPURDETAILLISTBYINVGOODSCODE({invgoodscode: this.purdetailCode}).then(res => {
        if(res.data.status == "200") {
          window.location.href = res.data.data;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      })
    },
    // 打开开票明细弹窗
    getShowConsumeinv(code){
      this.purdetailCode = code;
      this.purPageSize = 30;
      this.purCurrentPage = 1;
      this.getInvoiceListByInvgoodscode();
    },
    // 关闭开票申请明细弹窗
    getCloseConsumeinv(){
      this.consumeinvDlog = false;
    },
    // 获取开票申请明细列表
    getInvoiceListByInvgoodscode() {
      let getParams = {
        invgoodscode: this.purdetailCode,
        pageparam: {
          pagesize: this.purPageSize, //每页条数
          currentpage: this.purCurrentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      api.GET_INVOICELISTBYINVGOODSCODE(getParams).then(res => {
        if(res.data.status == "200") {
          this.invoiceRecordData = res.data.data;
          this.purPagebBean = res.data.pagebean;
          this.consumeinvDlog = true;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    // 接收分页信息
    invUpdatePage(size,num) {
      this.purPageSize = size;
      this.purCurrentPage = num;
      this.getInvoiceListByInvgoodscode();
    },
    // 导出开票申请明细列表
    exportInvoiceListByInvgoodscode() {
      this.loading = true;
      api.EXPORTINVOICELISTBYINVGOODSCODE({invgoodscode: this.purdetailCode}).then(res => {
        if(res.data.status == "200") {
          window.location.href = res.data.data;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      })
    },
    // 列表导出
    exportList() {
      let exportParams = {
        salercode: this.searchForm.salercode,
        invgoodsname: this.searchForm.invgoodsname,
        invkindinfo: this.searchForm.invkindinfo,
        taxrate: this.searchForm.taxrate,
        status: this.searchForm.status!==''?this.searchForm.status:null,
      }
      api.EXPORTINVGOODSINFOLIST(exportParams).then(res => {
        if(res.data.status == "200") {
          this.$message({
            type: 'success',
            message: res.data.message
          })
          window.location.href = res.data.data;
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      })
    },
    senderObtain3(val){
			 this.searchForm.salercode =val.infocode
		},
    //切换状态
    handleStatus(val){
      this.transferInfo = val;
      if(!val.status){
        MessageBox.confirm('确定需要禁用吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开票商品批量上下架
          this.batchUpdStatus();
        }).catch(() => {
        });
      } else {
        // 开票商品批量上下架
        this.batchUpdStatus();
      }
    },
    // 开票商品批量上下架
    batchUpdStatus() {
      let statusParams = {
        invgoodscodes: this.transferInfo.invgoodscode,
        status: this.transferInfo.status?0:1
      }
      api.Inv_BATCHUPDSTATUS(statusParams).then(res => {
        if(res.data.status == "200") {
          this.$message({
            type: 'success',
            message: res.data.message,
            offset: 200
          })
          this.getInvgoodsinfoList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.message,
            offset: 200
          })
        }
      })
    },
    // 打开详情弹窗
    getDetailShow(row){
      this.transferInfo = row;
      this.transferDetailShow = true;
    },
    // 关闭详情弹窗
    getDetailClose(){
      this.transferDetailShow = false;
    },
    // 打开poper上限时触发的方法
    mallShowPop(index,row){
      this.addRedForm.minprice = '';
      this.addRedForm.maxprice = '';
      this.addRedForm.issuppdecimal = row.issuppdecimal?true:false;
    },
    // 关闭poper上限时触发的方法
    mallClosePop(index){
      this.addRedForm.issuppdecimal = false;
    },
    // 关闭表格的pop弹出框
    getClosePop(type,row){
      if(type ==1) {
        if(Number(this.addRedForm.minprice) > row.unitprice) {
          this.$message.error({message:'单价区间最小值不能大于当前单价！',offset: 200})
          return false;
        }
        if(Number(this.addRedForm.maxprice) < row.unitprice) {
          this.$message.error({message:'单价区间最大值不能小于当前单价！',offset: 200})
          return false;
        }
        let priceParams = {
          invgoodscode: row.invgoodscode,
          minprice: Number(this.addRedForm.minprice),
          maxprice: Number(this.addRedForm.maxprice),
          issuppdecimal: this.addRedForm.issuppdecimal?1:0
        }
        api.UPDATEINVGOODSINFOPRICE(priceParams).then(res => {
          if(res.data.status == '200') {
            this.$message({
              type: 'success',
              message: res.data.message,
              offset: 200
            })
            this.getInvgoodsinfoList();
            document.querySelector("#app").click(); //为了点击空白处关闭弹框
          } else {
            this.$message({
              type: 'error',
              message: res.data.message,
              offset: 200
            })
          }
        })
      } else {
        document.querySelector("#app").click(); //为了点击空白处关闭弹框
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
    // 获取开票商品列表
    getInvgoodsinfoList() {
      let invParams = {
        salercode: this.searchForm.salercode,
        invgoodsname: this.searchForm.invgoodsname,
        invkindinfo: this.searchForm.invkindinfo,
        taxrate: this.searchForm.taxrate,
        status: this.searchForm.status!==''?this.searchForm.status:null,
        pageparam: {
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      api.GET_INVGOODSINFOLIST(invParams).then(res => {
        if(res.data.status == "200") {
          this.payRecordList = [];
          if(res.data.data && res.data.data != 'null') {
            this.payRecordList = res.data.data;
          }
          this.pagebBean = res.data.pagebean;
        }
      })
    },
    // 查询确定事件
    querySubmit(val) {
      this.currentPage = 1;
      this.getInvgoodsinfoList();
    },
    // 接收分页信息
    updatePage(size,num) {
      this.pageSize = size;
      this.currentPage = num;
      this.getInvgoodsinfoList();
    },
    // 情况检索条件
    emptyQuery() {
      this.searchForm.salercode = '';
      this.searchForm.invgoodsname = '';
      this.searchForm.invkindinfo = '';
      this.searchForm.taxrate = '';
      this.searchForm.status = '';
      this.currentPage = 1;
      this.getInvgoodsinfoList();
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted (){
    if(this.$route.params.monye){
      this.monye = true;
    }else{
      this.monye = false;
    }
    if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!=undefined) {
       this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
    }
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200);
    // 获取开票商品列表
    this.getInvgoodsinfoList()
  },
  destroyed(){
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.serialInput {width: 200px;border: 1px solid #dcdfe6;border-radius: 4px;display: inline-block;}
.serialInput >>> .el-form-item__content .el-input {width: 45%;}
.serialInput >>> .el-input__inner {border: none;text-align: center;}
.center{text-align: center;}
.addItem em{margin-right: 10px;}
.pdr70{padding-right: 70px;width: auto;}
/*详情弹窗 start*/
.seniorMdg >>> .el-dialog {width:600px;}
.basicWrap ul{padding:0 35px;width: 100%;}
.basicWrap ul li{margin:20px 0}
.basicWrap ul li:first-child{margin-top:10px}
.basicWrap ul li>em{color:#333;width:150px;display:inline-block;text-align:right;vertical-align:top}
.basicWrap ul li b{color:#999}
.rulrMemo{display: -webkit-flex; display: flex;}
.rulrMemo b{min-width:calc(100% - 150px);}
/*详情弹窗 end*/
.pl25{padding-left: 25px;}
.recordDlog>>>.el-dialog{min-width: 1400px;width: 80%;}
.recordDlog>>>.el-dialog__body{max-height: 580px!important;}
.recordDlog .topButton {padding-bottom:10px;text-align: right;}
.cursorHand i{font-size: 20px;margin-right: 5px;vertical-align: bottom;color: #666!important;}
.basicWrap ul li b .iconhand{font-size: 16px;vertical-align: bottom;}
</style>



// WEBPACK FOOTER //
// src/views/InvoiceManage/InvoiceGoodsManage.vue